export default {
    registerPromo1Title: "Promo 1",
    registerPromo1Body:  "Promo indhold",
    registerPromo2Title: "Promo 2",
    registerPromo2Body:  "Promo indhold"
};